import $ from 'jquery';


function initPricingPlans() {
    
}

export { initPricingPlans };
